import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const BingoComponent = React.lazy(() => import("../Components/RootComponents/BingoComponent"));
const BingoPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <BingoComponent />
      </Suspense>
    </Fragment>
  );
};

export default BingoPage;
